import { WorkState } from '../../../model/WorkState';
import { PsCompanyManagement } from '../../../model/PsCompanyManagement';

export class WorkSearchRequest {

    _page; // number
    _term; // string
    _state; // number[]
    _companyManagement; // PsCompanyManagement

    constructor(companyManagement) {
        this._page = 1;
        this._term = '';
        this._state = undefined;
        this._companyManagement = companyManagement;
    }

    setPage(page) {
        this._page = page;
    }

    setTerm(term) {
        this._term = term;
    }

    setState(state) {
        this._state =
            state === WorkState.ACTIVE ||
            state === WorkState.INACTIVE
                ? [state]
                : undefined;
    }

    asSubcontracted() {
        return this._companyManagement !== PsCompanyManagement.MY_OUTSOURCES;
    }

    body() {
        return {
            retrieve_work_contracts: false,
            retrieve_basic_data: true,
            criteria: {
                page: this._page,
                term: this._term,
                company_id: undefined,
                construction_id: undefined,
                construction_state_ids: this._state,
                constructions_subcontracted: this.asSubcontracted(),
            },
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/work/list/work-search/WorkSearchRequest.js